const initialState = {
  timezones: JSON.parse(localStorage.getItem('redux_sync_Timezones')) || [],
  fetching: false,
  fetched: false,
  error: null,
}

export default function reducer(state = initialState, action) {

  let payloadData

  switch (action.type) {
    case "TIMEZONES_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case "TIMEZONES_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "TIMEZONES_FETCH_FULFILLED":
      payloadData = action.payload.data
      localStorage.setItem('redux_sync_Timezones',JSON.stringify(payloadData))
      return {
        ...state,
        fetching: false,
        fetched: true,
        timezones: payloadData,
        errors: null,
      }
    case  'USER_SIGN_OUT_PENDING':
      localStorage.removeItem('redux_sync_Timezones')
      return {
        ...initialState,
        timezones: [],
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState,
        timezones: [],
      }
    default:
      return state
  }


}



// WEBPACK FOOTER //
// ./src/reducers/timezonesReducer.js